import { render } from "./BaseLoader.vue?vue&type=template&id=ad0df6dc&scoped=true"
import script from "./BaseLoader.vue?vue&type=script&lang=js"
export * from "./BaseLoader.vue?vue&type=script&lang=js"

import "./BaseLoader.vue?vue&type=style&index=0&id=ad0df6dc&lang=scss&scoped=true"

import exportComponent from "/home/production/domains/monteur.waterluxe.nl/monteur-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad0df6dc"]])

export default __exports__